import Actions from 'reducers/Search'
import { SearchService, ReleasesService } from 'services'
import { storeHelpers } from 'utils'
import type { AppDispatch } from 'types/store'

export const logSearch =
  (allToken = '') =>
  (dispatch: AppDispatch) => {
    dispatch(Actions.logSearch(allToken))
  }

export const search =
  (
    filter: string,
    section: string,
    pagesize: number,
    useAISearch = false,
    successCallback: (response?: any) => void = () => {},
    errorCallback: () => void = () => {},
    options: Record<string, any> = {}
  ) =>
  (dispatch: AppDispatch) => {
    dispatch(logSearch(filter) as any)
    storeHelpers
      .asyncGetStoreState()
      .then((state: any) => {
        const { genre: genreState, market: marketState } = state
        const params = {
          filter,
          section,
          pagesize,
          genres: genreState.selectedGenres.join(','),
          markets: marketState.selectedMarkets.map((item: any) => item.id).join(','),
        }
        const searchOptions = {
          ...options,
          useAISearch,
        }
        SearchService.search(params, searchOptions)
          .then((response: any) => {
            if (successCallback) {
              successCallback(response)
            }
          })
          .catch((error: any) => {
            console.warn(error)
            if (errorCallback) errorCallback()
          })
      })
      .catch((e: any) => {
        console.warn(e)
      })
  }

export const searchProfile =
  (
    artist: string,
    label: string,
    successCallback: (response?: any) => void = () => {},
    errorCallback: () => void = () => {},
    options: { page?: number; pagesize?: number } = {}
  ) =>
  (dispatch: AppDispatch) => {
    dispatch(logSearch(artist || label) as any)
    storeHelpers
      .asyncGetStoreState()
      .then((state: any) => {
        const { genre: genreState, market: marketState } = state
        const { page = 1, pagesize = 100 } = options
        const params = {
          artist,
          label,
          page,
          pagesize,
          genres: genreState.selectedGenres.join(','),
          markets: marketState.selectedMarkets.map((item: any) => item.id).join(','),
        }
        ReleasesService.search(params)
          .then((response: any) => {
            if (successCallback) {
              successCallback(response)
            }
          })
          .catch((error: any) => {
            console.warn(error)
            if (errorCallback) errorCallback()
          })
      })
      .catch((e: any) => {
        console.warn(e)
      })
  }

export default { search, searchProfile, logSearch }
